<script setup lang="ts">
import { ref } from 'vue';
import { useClipboard } from '@vueuse/core';
import { BTooltip } from 'bootstrap-vue-next';

export interface Props {
  show?: boolean;
  content: string | number;
  type?: string;
}
const props = withDefaults(defineProps<Props>(), {
  show: false,
  content: '',
  type: ''
});

const { copied, copy, isSupported } = useClipboard();

const state = ref<'success' | 'danger' | null>(null);

function resetTooltip() {
  setTimeout(() => {
    state.value = null;
  }, 3000);
}

function evalCopy() {
  if (copied) {
    state.value = 'success';
  } else {
    state.value = 'danger';
  }
}

function runCopy() {
  copy(String(props.content)).then(() => {
    evalCopy();
    resetTooltip();
  });
}
</script>

<template lang="pug">
span.ms-2
  template(v-if="show")
    BTooltip(v-if="isSupported")
      template(#target)
        button.btn.btn-link.p-0(:aria-label="`Copy ${type || 'content'}`" @click="runCopy")
          FontAwesomeIcon(:icon="['far', 'copy']")
      strong.text-success(v-if="state === 'success'") ✓ Copied {{ type }}
      strong.text-danger(v-else-if="state === 'danger'") X Failed to copy {{ type }}
      span.text-nowrap(v-else) Copy {{ type }}
  button.btn.btn-link.p-0(v-else style="visibility: hidden; pointer-events: none;" disabled tabindex="-1")
    FontAwesomeIcon(:icon="['far', 'copy']")
</template>
